module.exports = __webpack_public_path__ + "img/exit.48cd0100.svg";